import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";

const personService = {}
let base_url = baseURL.person

// 个人分页查询
personService.querydishonesty = function (data) {
    return request ({
        url: '/v1/report/report-result',
        method: 'get',
        params:data,
        baseURL: base_url,
    })
}
 //  个人/单位失信审核详情
 personService.querydetails = function(id){
    return request ({
        url: '/v1/report/'+ id,
        method: 'get',
        baseURL: base_url,
    })
 }
  //  个人/单位流程图
  personService.querychart = function(id){
    return request ({
        url: '/v1/report/'+ id,
        method: 'get',
        baseURL: base_url,
    })
 }
  // 个人文件下载
personService.addfiles = function (id) {
    return request ({
        url: `/v1/file-deal/file-download?id=${id}`,
        method: 'get',
        baseURL: base_url,
        responseType: 'blob'
    })
}
// 获取验证码
personService.queryphone = function (phone) {
    return request ({
        url: `/v1/send/code?phone=${phone}`,
        method: 'get',
        baseURL: base_url,
    })
}
// 撤回
personService.withdraw = function (id) {
    return request ({
        url: `/v1/report/` + id,
        method: 'put',
        baseURL: base_url,
    })
}
// 撤销
personService.delete = function (id) {
    return request ({
        url: `/v1/report/` + id,
        method: 'delete',
        baseURL: base_url,
    })
}
export default personService